import { fetchSession } from "../api/client.js";

/**
 * ログインの状態の控え（<c>ClientApp/session/auth-hint.ts</c> と同じ名前・同じ形。docs/screens/06 §3）。
 *
 * 静的な画面のヘッダーは、控えがあれば描く前に管理センターの入口とログイン中の出入口を出す。
 * <b>ログインが済んでページごと移るときは、ヘッダーが読み直す前にページが替わる</b>ので、
 * 移る前にここで読んで控えておく（<c>forms/use-api-form.ts</c>）。画面の中で移るときはヘッダーが読み直して控える。
 *
 * <b>控えは見た目のためだけ。</b>開けるかどうかはサーバが毎回判定する。トークンは入れない。
 * 読み書きできなくても、次のページの入口が /api/session を読んでから出るだけ。
 */

/** 控えの名前（ClientApp と同じ）。 */
export const authHintKey = "portal.authHint";

const storage = (): Storage | undefined => {
    try {
        return globalThis.sessionStorage;
    } catch {
        return undefined;
    }
};

/** 控えを消す（ログインが切れたとき）。 */
export function clearAuthHint(): void {
    try {
        storage()?.removeItem(authHintKey);
    } catch {
        // 消せなくても、次のページで /api/session の結果に直る
    }
}

/** いまの状態を読んで控える。ログインしていなければ消す。読めなければ何もしない。 */
export async function rememberAuthHint(): Promise<void> {
    try {
        const session = await fetchSession();
        if (!session.signedIn) {
            clearAuthHint();
            return;
        }
        storage()?.setItem(authHintKey, JSON.stringify({
            signedIn: true,
            admin: session.canOpenAdmin === true,
            email: session.email ?? "",
        }));
    } catch {
        // 読めない・書けないなら、次のページで遅れて出るだけ
    }
}
